import { render, staticRenderFns } from "./EditCourseModule.vue?vue&type=template&id=9fe589d4&scoped=true"
import script from "./EditCourseModule.vue?vue&type=script&lang=js"
export * from "./EditCourseModule.vue?vue&type=script&lang=js"
import style0 from "./EditCourseModule.vue?vue&type=style&index=0&id=9fe589d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe589d4",
  null
  
)

export default component.exports